import { Tr } from '@chakra-ui/react'
import React, { useState } from 'react'
import { Column, RowData, TableType } from './MasterTable'
import TableCell from './TableCell'

interface TableRowProps {
  columns: Column[]
  row: RowData
  onRowClick?: (row: RowData) => void
  onSearch?: (row: RowData) => void
  onOpenNewTab?: (row: RowData) => void
  onRowIntent?: (row: RowData) => void
  selectedRows: (number | string)[]
  onSelectRow: (id: number | string, isChecked: boolean) => void
  tableType: TableType
}

const TableRowItem: React.FC<TableRowProps> = ({
  columns,
  row,
  onRowClick,
  onOpenNewTab,
  onSearch,
  onRowIntent,
  selectedRows,
  onSelectRow,
  tableType,
}) => {
  const [isHovered, setIsHovered] = useState(false)

  if (!row) {
    return null
  }

  const handleRowClick = () => {
    onRowClick?.(row)
  }

  const isSelected = selectedRows?.includes(row?.id) ?? false

  return (
    <Tr
      onClick={handleRowClick}
      cursor={onRowClick ? 'pointer' : 'auto'}
      onMouseEnter={() => {
        setIsHovered(true)
        onRowIntent?.(row)
      }}
      onFocus={() => onRowIntent?.(row)}
      onPointerDown={() => onRowIntent?.(row)}
      onMouseLeave={() => setIsHovered(false)}
      backgroundColor={isHovered ? 'solid.25' : 'transparent'}
      py="0px"
    >
      {columns.map((column) => (
        <TableCell
          key={column.accessor}
          column={column}
          value={row[column.accessor]}
          row={row}
          onOpenNewTab={onOpenNewTab}
          onSearch={onSearch}
          isSelected={isSelected}
          onSelectRow={onSelectRow}
          tableType={tableType}
          isHovered={isHovered}
        />
      ))}
    </Tr>
  )
}

export default TableRowItem
